import "core-js/modules/es.object.from-entries";
import _slicedToArray from "/vusers/tom/webroot/mikro-makro.com/htdocs/node_modules/.pnpm/@babel+runtime@7.17.8/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useRef, useState, useEffect, useCallback, useMemo, createElement, useDebugValue } from 'react';
import { createContext, useContextUpdate, useContext, useContextSelector, useBridgeValue, BridgeProvider } from 'use-context-selector';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var hasInitialValue = function hasInitialValue(atom) {
  return 'init' in atom;
};

var createState = function createState(initialValues) {
  var state = {
    a: new WeakMap(),
    m: new Map(),
    w: new Map()
  };

  if (initialValues) {
    var _iterator = _createForOfIteratorHelper(initialValues),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            _atom = _step$value[0],
            value = _step$value[1];

        var atomState = {
          v: value,
          r: 0,
          d: new Map()
        };

        if (typeof process === 'object' && process.env.NODE_ENV !== 'production') {
          Object.freeze(atomState);
        }

        state.a.set(_atom, atomState);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return state;
};

var getAtomState = function getAtomState(state, atom) {
  return state.w.get(atom) || state.a.get(atom);
};

var copyWip = function copyWip(state, copyingState) {
  if (state.w.size && typeof process === 'object' && process.env.NODE_ENV !== 'production') {
    console.warn('[Bug] wip not empty');
  }

  return _extends({}, state, {
    w: copyingState.w
  });
};

var wipAtomState = function wipAtomState(state, atom) {
  var atomState = getAtomState(state, atom);

  if (atomState) {
    atomState = _extends({}, atomState); // copy
  } else {
    atomState = {
      r: 0,
      d: new Map()
    };

    if (hasInitialValue(atom)) {
      atomState.v = atom.init;
    }
  }

  var nextState = _extends({}, state, {
    w: new Map(state.w).set(atom, atomState)
  });

  return [atomState, nextState];
};

var addDependency = function addDependency(state, atom, dependency) {
  var _wipAtomState = wipAtomState(state, atom),
      _wipAtomState2 = _slicedToArray(_wipAtomState, 2),
      atomState = _wipAtomState2[0],
      nextState = _wipAtomState2[1];

  var dependencyState = getAtomState(state, dependency);

  if (atomState) {
    if (dependencyState && atomState.d.get(dependency) === dependencyState.r) {
      return state;
    } else {
      var _dependencyState$r;

      atomState.d = new Map(atomState.d).set(dependency, (_dependencyState$r = dependencyState == null ? void 0 : dependencyState.r) != null ? _dependencyState$r : 0);
      atomState.r++;
    }
  } else if (typeof process === 'object' && process.env.NODE_ENV !== 'production') {
    console.warn('[Bug] add dependency failed', atom);
  }

  return nextState;
};

var replaceDependencies = function replaceDependencies(state, atomState, dependencies) {
  if (dependencies) {
    atomState.d = new Map(Array.from(dependencies).map(function (a) {
      var _getAtomState$r, _getAtomState;

      return [a, (_getAtomState$r = (_getAtomState = getAtomState(state, a)) == null ? void 0 : _getAtomState.r) != null ? _getAtomState$r : 0];
    }));
  }
};

var setAtomValue = function setAtomValue(state, atom, value, dependencies, promise) {
  var _wipAtomState3 = wipAtomState(state, atom),
      _wipAtomState4 = _slicedToArray(_wipAtomState3, 2),
      atomState = _wipAtomState4[0],
      nextState = _wipAtomState4[1];

  if (promise && promise !== atomState.rp) {
    return state;
  }

  delete atomState.re;
  delete atomState.rp;
  atomState.v = value;
  atomState.r++;
  replaceDependencies(nextState, atomState, dependencies);
  return nextState;
};

var setAtomReadError = function setAtomReadError(state, atom, error, dependencies, promise) {
  var _wipAtomState5 = wipAtomState(state, atom),
      _wipAtomState6 = _slicedToArray(_wipAtomState5, 2),
      atomState = _wipAtomState6[0],
      nextState = _wipAtomState6[1];

  if (promise && promise !== atomState.rp) {
    return state;
  }

  delete atomState.rp;
  atomState.re = error;
  atomState.r++;
  replaceDependencies(nextState, atomState, dependencies);
  return nextState;
};

var setAtomReadPromise = function setAtomReadPromise(state, atom, promise, dependencies) {
  var _wipAtomState7 = wipAtomState(state, atom),
      _wipAtomState8 = _slicedToArray(_wipAtomState7, 2),
      atomState = _wipAtomState8[0],
      nextState = _wipAtomState8[1];

  atomState.rp = promise;
  atomState.r++;
  replaceDependencies(nextState, atomState, dependencies);
  return nextState;
};

var setAtomWritePromise = function setAtomWritePromise(state, atom, promise) {
  var _wipAtomState9 = wipAtomState(state, atom),
      _wipAtomState10 = _slicedToArray(_wipAtomState9, 2),
      atomState = _wipAtomState10[0],
      nextState = _wipAtomState10[1];

  if (promise) {
    atomState.wp = promise;
  } else {
    delete atomState.wp;
  }

  atomState.r++;
  return nextState;
};

var readAtomState = function readAtomState(state, updateState, atom, force) {
  if (!force) {
    var atomState = getAtomState(state, atom);

    if (atomState && Array.from(atomState.d.entries()).every(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          a = _ref2[0],
          r = _ref2[1];

      var _getAtomState2;

      return ((_getAtomState2 = getAtomState(state, a)) == null ? void 0 : _getAtomState2.r) === r;
    })) {
      return [atomState, state];
    }
  }

  var asyncState = _extends({}, state, {
    w: new Map()
  }); // empty wip


  var isSync = true;
  var nextState = state;
  var error;
  var promise;
  var value;
  var dependencies = new Set();
  var flushDependencies = false;

  try {
    var promiseOrValue = atom.read(function (a) {
      if (dependencies) {
        dependencies.add(a);
      }

      if (!isSync) {
        updateState(function (prev) {
          return addDependency(prev, atom, a);
        });
      }

      if (a !== atom) {
        var _aState;

        if (isSync) {
          ;

          var _readAtomState = readAtomState(nextState, updateState, a);

          var _readAtomState2 = _slicedToArray(_readAtomState, 2);

          _aState = _readAtomState2[0];
          nextState = _readAtomState2[1];
        } else {
          ;

          var _readAtomState3 = readAtomState(asyncState, updateState, a);

          var _readAtomState4 = _slicedToArray(_readAtomState3, 2);

          _aState = _readAtomState4[0];
          asyncState = _readAtomState4[1];
        }

        if (_aState.re) {
          throw _aState.re; // read error
        }

        if (_aState.rp) {
          throw _aState.rp; // read promise
        }

        return _aState.v; // value
      } // a === atom


      var aState = getAtomState(nextState, a);

      if (aState) {
        if (aState.rp) {
          throw aState.rp; // read promise
        }

        return aState.v; // value
      }

      if (hasInitialValue(a)) {
        return a.init;
      }

      throw new Error('no atom init');
    });

    if (promiseOrValue instanceof Promise) {
      promise = promiseOrValue.then(function (value) {
        var dependenciesToReplace = dependencies;
        dependencies = null;
        updateState(function (prev) {
          return setAtomValue(copyWip(prev, asyncState), atom, value, dependenciesToReplace, promise);
        });
      }).catch(function (e) {
        var dependenciesToReplace = dependencies;
        dependencies = null;
        updateState(function (prev) {
          return setAtomReadError(copyWip(prev, asyncState), atom, e instanceof Error ? e : new Error(e), dependenciesToReplace, promise);
        });
      });
    } else {
      value = promiseOrValue;
      flushDependencies = true;
    }
  } catch (errorOrPromise) {
    if (errorOrPromise instanceof Promise) {
      promise = errorOrPromise.then(function () {
        updateState(function (prev) {
          var _readAtomState5 = readAtomState(prev, updateState, atom, true),
              _readAtomState6 = _slicedToArray(_readAtomState5, 2),
              nextNextState = _readAtomState6[1];

          if (nextNextState.w.size) {
            return nextNextState;
          }

          return prev;
        });
      });
    } else if (errorOrPromise instanceof Error) {
      error = errorOrPromise;
    } else {
      error = new Error(errorOrPromise);
    }

    flushDependencies = true;
  }

  if (error) {
    nextState = setAtomReadError(nextState, atom, error, flushDependencies && dependencies);
  } else if (promise) {
    nextState = setAtomReadPromise(nextState, atom, promise, flushDependencies && dependencies);
  } else {
    nextState = setAtomValue(nextState, atom, value, flushDependencies && dependencies);
  }

  if (flushDependencies) {
    dependencies = null;
  } else {
    // add dependency temporarily
    dependencies.forEach(function (dependency) {
      nextState = addDependency(nextState, atom, dependency);
    });
  }

  isSync = false;
  return [getAtomState(nextState, atom), nextState];
};

var readAtom = function readAtom(state, updateState, readingAtom) {
  var _readAtomState7 = readAtomState(state, updateState, readingAtom),
      _readAtomState8 = _slicedToArray(_readAtomState7, 2),
      atomState = _readAtomState8[0],
      nextState = _readAtomState8[1]; // merge back wip


  nextState.w.forEach(function (atomState, atom) {
    state.w.set(atom, atomState);
  });
  return atomState;
};

var addAtom = function addAtom(state, addingAtom, useId) {
  var dependents = state.m.get(addingAtom);

  if (dependents) {
    dependents.add(useId);
  } else {
    state.m.set(addingAtom, new Set([useId]));
  }
};

var delAtom = function delAtom(state, deletingAtom, useId) {
  var del = function del(atom, dependent) {
    var dependents = state.m.get(atom);

    if (!dependents) {
      return;
    }

    dependents.delete(dependent);

    if (!dependents.size) {
      state.m.delete(atom);
      var atomState = getAtomState(state, atom);

      if (atomState) {
        if (atomState.rp && typeof process === 'object' && process.env.NODE_ENV !== 'production') {
          console.warn('[Bug] deleting atomState with read promise', atom);
        }

        atomState.d.forEach(function (_, a) {
          del(a, atom);
        });
      } else if (typeof process === 'object' && process.env.NODE_ENV !== 'production') {
        console.warn('[Bug] atomState not defined', atom);
      }
    }
  };

  del(deletingAtom, useId);
};

var updateDependentsState = function updateDependentsState(state, updateState, atom) {
  var dependents = state.m.get(atom);

  if (!dependents) {
    // no dependents found
    // this may happen if async function is resolved before commit.
    // not certain this is going to be an issue in some cases.
    return state;
  }

  var nextState = state;
  dependents.forEach(function (dependent) {
    if (dependent === atom || typeof dependent === 'symbol' || !getAtomState(nextState, dependent)) {
      return;
    }

    var _readAtomState9 = readAtomState(nextState, updateState, dependent, true),
        _readAtomState10 = _slicedToArray(_readAtomState9, 2),
        dependentState = _readAtomState10[0],
        nextNextState = _readAtomState10[1];

    var promise = dependentState.rp;

    if (promise) {
      promise.then(function () {
        updateState(function (prev) {
          return updateDependentsState(prev, updateState, dependent);
        });
      });
      nextState = nextNextState;
    } else {
      nextState = updateDependentsState(nextNextState, updateState, dependent);
    }
  });
  return nextState;
};

var writeAtomState = function writeAtomState(state, updateState, atom, update, pendingPromises) {
  var atomState = getAtomState(state, atom);

  if (atomState && atomState.wp) {
    var promise = atomState.wp.then(function () {
      updateState(function (prev) {
        return writeAtomState(prev, updateState, atom, update);
      });
    });

    if (pendingPromises) {
      pendingPromises.push(promise);
    }

    return state;
  }

  var nextState = state;
  var isSync = true;

  try {
    var promiseOrVoid = atom.write(function (a) {
      var aState = getAtomState(nextState, a);

      if (!aState) {
        if (typeof process === 'object' && process.env.NODE_ENV !== 'production') {
          console.warn('[Bug] writeAtomState no state', a);
        }

        return a.init;
      }

      if (aState.rp && typeof process === 'object' && process.env.NODE_ENV !== 'production') {
        // TODO will try to detect this
        console.warn('Reading pending atom state in write operation. We need to detect this and fallback. Please file an issue with repro.', a);
      }

      return aState.v;
    }, function (a, v) {
      if (a === atom) {
        if (isSync) {
          nextState = updateDependentsState(setAtomValue(nextState, a, v, false), updateState, a);
        } else {
          updateState(function (prev) {
            return updateDependentsState(setAtomValue(prev, a, v, false), updateState, a);
          });
        }
      } else {
        if (isSync) {
          nextState = writeAtomState(nextState, updateState, a, v);
        } else {
          updateState(function (prev) {
            return writeAtomState(prev, updateState, a, v);
          });
        }
      }
    }, update);

    if (promiseOrVoid instanceof Promise) {
      if (pendingPromises) {
        pendingPromises.push(promiseOrVoid);
      }

      nextState = setAtomWritePromise(nextState, atom, promiseOrVoid.then(function () {
        updateState(function (prev) {
          return setAtomWritePromise(prev, atom);
        });
      }));
    }
  } catch (e) {
    if (pendingPromises && pendingPromises.length) {
      pendingPromises.push(new Promise(function (_resolve, reject) {
        reject(e);
      }));
    } else {
      throw e;
    }
  }

  isSync = false;
  return nextState;
};

var writeAtom = function writeAtom(updateState, writingAtom, update) {
  var pendingPromises = [];
  updateState(function (prev) {
    var nextState = writeAtomState(prev, updateState, writingAtom, update, pendingPromises);
    return nextState;
  });

  if (pendingPromises.length) {
    return new Promise(function (resolve, reject) {
      var loop = function loop() {
        var len = pendingPromises.length;

        if (len === 0) {
          resolve();
        } else {
          Promise.all(pendingPromises).then(function () {
            pendingPromises.splice(0, len);
            loop();
          }).catch(reject);
        }
      };

      loop();
    });
  }
};

var updateDependentsMap = function updateDependentsMap(state) {
  state.w.forEach(function (atomState, atom) {
    var _state$a$get;

    var prevDependencies = (_state$a$get = state.a.get(atom)) == null ? void 0 : _state$a$get.d;

    if (prevDependencies === atomState.d) {
      return;
    }

    var dependencies = new Set(atomState.d.keys());

    if (prevDependencies) {
      prevDependencies.forEach(function (_, a) {
        var aDependents = state.m.get(a);

        if (dependencies.has(a)) {
          // not changed
          dependencies.delete(a);
        } else {
          var newDependents = new Set(aDependents);
          newDependents.delete(atom);
          state.m.set(a, newDependents);
        }
      });
    }

    dependencies.forEach(function (a) {
      var aDependents = state.m.get(a);
      var newDependents = new Set(aDependents).add(atom);
      state.m.set(a, newDependents);
    });
  });
}; // commit wip


var commitState = function commitState(state) {
  if (state.w.size) {
    updateDependentsMap(state);
    state.w.forEach(function (atomState, atom) {
      if (typeof process === 'object' && process.env.NODE_ENV !== 'production') {
        Object.freeze(atomState);
      }

      state.a.set(atom, atomState);
    });
    state.w.clear();
  }
};

var ContextsMap = new Map();

var getContexts = function getContexts(scope) {
  if (!ContextsMap.has(scope)) {
    ContextsMap.set(scope, [createContext(null), createContext(null)]);
  }

  return ContextsMap.get(scope);
};

var isReactExperimental = !!(typeof process === 'object' && process.env.IS_REACT_EXPERIMENTAL) || !!React.unstable_useMutableSource;

var defaultContextUpdate = function defaultContextUpdate(f) {
  return f();
};

var InnerProvider = function InnerProvider(_ref3) {
  var r = _ref3.r,
      c = _ref3.c,
      children = _ref3.children;
  var contextUpdate = useContextUpdate(c);

  if (isReactExperimental && r.current === defaultContextUpdate) {
    r.current = function (f) {
      return contextUpdate(f);
    };
  }

  return children;
};

var Provider = function Provider(_ref4) {
  var initialValues = _ref4.initialValues,
      scope = _ref4.scope,
      children = _ref4.children;
  var contextUpdateRef = useRef(defaultContextUpdate);

  var _useState = useState(function () {
    return createState(initialValues);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var lastStateRef = useRef(state);
  useEffect(function () {
    commitState(state);
    lastStateRef.current = state;
  });
  var updateState = useCallback(function (updater) {
    commitState(lastStateRef.current);
    lastStateRef.current = updater(lastStateRef.current);
    contextUpdateRef.current(function () {
      commitState(lastStateRef.current);
      setState(lastStateRef.current);
    });
  }, []);
  var actions = useMemo(function () {
    return {
      add: function add(atom, id) {
        addAtom(lastStateRef.current, atom, id);
      },
      del: function del(atom, id) {
        delAtom(lastStateRef.current, atom, id);
      },
      read: function read(state, atom) {
        return readAtom(state, updateState, atom);
      },
      write: function write(atom, update) {
        return writeAtom(updateState, atom, update);
      }
    };
  }, [updateState]);

  if (typeof process === 'object' && process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useDebugState(state);
  }

  var _getContexts = getContexts(scope),
      _getContexts2 = _slicedToArray(_getContexts, 2),
      ActionsContext = _getContexts2[0],
      StateContext = _getContexts2[1];

  return createElement(ActionsContext.Provider, {
    value: actions
  }, createElement(StateContext.Provider, {
    value: state
  }, createElement(InnerProvider, {
    r: contextUpdateRef,
    c: StateContext
  }, children)));
};

var atomToPrintable = function atomToPrintable(atom) {
  return atom.debugLabel || atom.toString();
};

var isAtom = function isAtom(x) {
  return typeof x !== 'symbol';
};

var stateToPrintable = function stateToPrintable(state) {
  return Object.fromEntries(Array.from(state.m.entries()).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        atom = _ref6[0],
        dependents = _ref6[1];

    var atomState = state.a.get(atom) || {};
    return [atomToPrintable(atom), {
      value: atomState.re || atomState.rp || atomState.wp || atomState.v,
      dependents: Array.from(dependents).filter(isAtom).map(atomToPrintable)
    }];
  }));
};

var useDebugState = function useDebugState(state) {
  useDebugValue(state, stateToPrintable);
};

var keyCount = 0; // global key count for all atoms

function atom(read, write) {
  var key = "atom".concat(++keyCount);
  var config = {
    toString: function toString() {
      return key;
    }
  };

  if (typeof read === 'function') {
    config.read = read;
  } else {
    config.init = read;

    config.read = function (get) {
      return get(config);
    };

    config.write = function (get, set, update) {
      set(config, typeof update === 'function' ? update(get(config)) : update);
    };
  }

  if (write) {
    config.write = write;
  }

  return config;
}

function assertContextValue(x, scope) {
  if (!x) {
    throw new Error("Please use <Provider".concat(scope ? " scope=".concat(String(scope)) : '', ">"));
  }
}

var isWritable = function isWritable(atom) {
  return !!atom.write;
};

function useAtom(atom) {
  var _getContexts3 = getContexts(atom.scope),
      _getContexts4 = _slicedToArray(_getContexts3, 2),
      ActionsContext = _getContexts4[0],
      StateContext = _getContexts4[1];

  var actions = useContext(ActionsContext);
  assertContextValue(actions, atom.scope);
  var value = useContextSelector(StateContext, useCallback(function (state) {
    assertContextValue(state);
    var atomState = actions.read(state, atom);

    if (atomState.re) {
      throw atomState.re; // read error
    }

    if (atomState.rp) {
      throw atomState.rp; // read promise
    }

    if (atomState.wp) {
      throw atomState.wp; // write promise
    }

    if ('v' in atomState) {
      return atomState.v;
    }

    throw new Error('no atom value');
  }, [atom, actions]));
  useEffect(function () {
    var id = Symbol();
    actions.add(atom, id);
    return function () {
      actions.del(atom, id);
    };
  }, [actions, atom]);
  var setAtom = useCallback(function (update) {
    if (isWritable(atom)) {
      return actions.write(atom, update);
    } else {
      throw new Error('not writable atom');
    }
  }, [atom, actions]);
  useDebugValue(value);
  return [value, setAtom];
}

var useBridge = function useBridge(scope) {
  var _getContexts5 = getContexts(scope),
      _getContexts6 = _slicedToArray(_getContexts5, 2),
      ActionsContext = _getContexts6[0],
      StateContext = _getContexts6[1];

  var actions = useBridgeValue(ActionsContext);
  var state = useBridgeValue(StateContext);
  return useMemo(function () {
    return [actions, state];
  }, [actions, state]);
};

var Bridge = function Bridge(_ref7) {
  var value = _ref7.value,
      scope = _ref7.scope,
      children = _ref7.children;

  var _value = _slicedToArray(value, 2),
      actions = _value[0],
      state = _value[1];

  var _getContexts7 = getContexts(scope),
      _getContexts8 = _slicedToArray(_getContexts7, 2),
      ActionsContext = _getContexts8[0],
      StateContext = _getContexts8[1];

  return createElement(BridgeProvider, {
    context: ActionsContext,
    value: actions
  }, createElement(BridgeProvider, {
    context: StateContext,
    value: state
  }, children));
};

export { Bridge, Provider, atom, useAtom, useBridge };